import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setSite} from '../../actions/action_site';
import actions from '../../actions/actions';
import './BirdhouseContainer.less';
import BirdhouseComponent from '../BirdhouseComponent/BirdhouseComponent';
import SiteHeader from '@homeaway/react-site-header';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return (
        {
            site: state.site,
            serviceUrl: state.serviceUrl,
            experiments: state.experiments,
            ticket: state.ticket,
            landingPage: state.landingPage
        }
    );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({setSite, triggerEdapEvent: actions.triggerEdapEvent}, dispatch);
}

@connect(mapStateToProps, mapDispatchToProps)
class BirdhouseContainer extends Component {
    componentDidMount() {
        window.ha.userTiming.mark('primary.action.rendered');
    }

    render() {
        const siteHeaderProps = {
            dataUrl: '/traveler/api/header',
            siteName: this.props.site.siteName
        };

        return (
            <div className="center-block text-center BirdhouseContainer">
                <SiteHeader {...siteHeaderProps} withoutTray withoutNav withoutListYourProperty/>
                <BirdhouseComponent site={this.props.site}
                    serviceUrl={this.props.serviceUrl}
                    triggerEdapEvent={this.props.triggerEdapEvent}
                    experiments={this.props.experiments}
                    ticket={this.props.ticket}
                    landingPage={this.props.landingPage}
                />
            </div>
        );
    }
}

export default BirdhouseContainer;



// WEBPACK FOOTER //
// ./src/universal/components/BirdhouseContainer/BirdhouseContainer.js